// The units of measure a product can be sold in, as DGII Tabla IV codes (see unidadesMedida.js):
// Cilindro (the default), Kilogramo, Litro and Metro Cúbico. Keep in step with backend/data/productUnits.js.
export const PRODUCT_UNIT_CODES = [9, 21, 24, 28];
export const DEFAULT_UNIT_CODE = 9; // Cilindro
